import React, { Suspense } from 'react';
import Spinner from '../../components/spinner';

// Lazy-loaded components
const AboutPageGetKnow = React.lazy(() => import('../about/AboutPageGetItKnow'));
const AboutPageHeader = React.lazy(() => import('../about/AboutPageHeader'));
const AboutPageOurJourney = React.lazy(() => import('../about/AboutPageOurJourney'));
const AboutPageOurApproch = React.lazy(() => import('../about/AboutPageOurApproch'));
const AboutPageCta = React.lazy(() => import('../about/AboutPageCta'));



function AboutUs() {
  return (
    <div className="page-wrapper">
   
      {/* Suspense to handle lazy loading */}
      <Suspense fallback={<Spinner />}>
      
       <AboutPageHeader />
       <AboutPageGetKnow />
       <AboutPageOurJourney />
       <AboutPageOurApproch />
       <AboutPageCta />

      </Suspense>
    </div>
  );
}

export default AboutUs;
